module.exports = __webpack_public_path__ + "media/assets/images/flags/sg-5ab776c601de9d68b5c73f7ec18a946e.svg";